







































import { Component, Vue } from "vue-property-decorator";
import { MenuService } from "@/services/menu-service";
import { Action } from "vuex-class";

@Component
export default class Sidebar extends Vue {
  menuService: MenuService = new MenuService();
  menuList: any = [];
  
  @Action("setState", { namespace: "Menu" })
  setState: any;

  async getNavigation() {
    const res = await this.menuService.getNavigation();
    if (res) {
      const navList = res.filter((e: any) => e != null && e.route);
      this.$set(this, "menuList", navList);
      this.setState(navList);
    }
    return res;
  }
}
